import { render, staticRenderFns } from "./download-sorkorlor.vue?vue&type=template&id=50e9fbc0&scoped=true&"
import script from "./download-sorkorlor.vue?vue&type=script&lang=js&"
export * from "./download-sorkorlor.vue?vue&type=script&lang=js&"
import style0 from "./download-sorkorlor.vue?vue&type=style&index=0&id=50e9fbc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9fbc0",
  null
  
)

export default component.exports